import { queryOptions } from "@tanstack/react-query";
import { getCoordinatorApi } from "@/lib/api";
import {
  type OrganizationLoggingPolicy,
  organizationLoggingPolicySchema,
  POLICY_UNAVAILABLE,
} from "../types";
import type { CoordinatorEnvelope } from "./envelope";
import { organizationLoggingKeys } from "./query-keys";

/**
 * Reads the organization's own record rather than the org list the switcher uses.
 * That list is assembled from the shared org/project context, which carries
 * identity and nothing about policy.
 */
export const organizationLoggingQueryOptions = (organizationId: string) =>
  queryOptions<OrganizationLoggingPolicy>({
    queryKey: organizationLoggingKeys.policy(organizationId),
    queryFn: async () => {
      const api = getCoordinatorApi({ organizationId });
      const { data } = await api.get<CoordinatorEnvelope<unknown>>("/metadata");
      const parsed = organizationLoggingPolicySchema.safeParse(data.data);
      if (!parsed.success) {
        throw new Error(POLICY_UNAVAILABLE);
      }
      return parsed.data;
    },
  });
